import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {

    private readonly storage: Storage = sessionStorage;

    get<T>(key: string): T | null {
        const raw: string | null = this.storage.getItem(key);

        if (raw === null) {
            return null;
        }

        try {
            return JSON.parse(raw) as T;
        } catch {
            return null;
        }
    }

    set<T>(key: string, value: T): void {
        this.storage.setItem(key, JSON.stringify(value));
    }

    remove(key: string): void {
        this.storage.removeItem(key);
    }

    clear(): void {
        this.storage.clear();
    }

    exists(key: string): boolean {
        return this.storage.getItem(key) !== null;
    }
}
